import { Component, inject, signal } from '@angular/core';
import { IconComponent, LoadingComponent } from '@gains-com/ui-angular';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MatIconButton } from '@angular/material/button';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatPrefix } from '@angular/material/input';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, debounceTime, distinctUntilChanged, startWith, tap } from 'rxjs';
import { GameService } from '../../core/game.service';
import { switchMap } from 'rxjs/operators';
import { GameCardComponent } from '../game-card/game-card.component';
import { Analytics } from '../../core/analytics/analytics.service';
import { DeviceModeViewService } from '../../core/view-states/device-mode-view.service';

@Component({
  selector: 'app-search-games-dialog',
  imports: [
    IconComponent,
    MatIconButton,
    FormsModule,
    MatFormField,
    MatInput,
    MatPrefix,
    MatFormField,
    ReactiveFormsModule,
    GameCardComponent,
    LoadingComponent,
  ],
  templateUrl: './search-games-dialog.component.html',
  styleUrl: './search-games-dialog.component.scss',
})
export class SearchGamesDialogComponent {

  readonly dialogRef = inject(DialogRef);
  private readonly _analytics = inject(Analytics);
  data: string = inject(DIALOG_DATA);

  private readonly _gameService = inject(GameService);
  private readonly _deviceMode = inject(DeviceModeViewService);

  gamesLoading = signal(false);

  nameSearchFormControl = new FormControl(this.data ?? '');
  games = toSignal(
    combineLatest([
      this.nameSearchFormControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        startWith(this.data ?? ''),
        tap((nameSearch) => this._analytics.trackEvent('game_search', { search_term: nameSearch })),
      ),
      toObservable(this._deviceMode.merchCatalog).pipe(distinctUntilChanged()),
    ]).pipe(
      switchMap(([nameSearch, isMerch]) => {
        this.gamesLoading.set(true);
        return this._gameService
          .getGames$({
            page: 0,
            pageSize: 50,
            enabled: true,
            nameSearch: nameSearch ?? undefined,
            isMerch,
          })
          .pipe(tap(() => this.gamesLoading.set(false)));
      }),
    ),
  );
}
